module.exports = __webpack_public_path__ + "img/next.d9492f18.svg";